export default "__VITE_ASSET__BLmeCfcZ__"